//this approach describes behavior touchSensor from dnd-kit libbrary
//export to Lesson.js

export const TouchSensorOptions = {
    activationConstraint: {
        delay: 250, // Задержка в мс
        tolerance: 5, // Допустимое перемещение в пикселях
    },
};
